/*
  Viworo — Vorlesefunktion fuer Ratgeber-Artikel (DE/IT/EN)
  Angelegt 2026-07-30 fuer die Serie "Ascoltare il corpo / Auf den Koerper hoeren".

  Haengt sich automatisch an jeden Artikel mit der Wrapper-Klasse .viworo-articolo.
  Nutzt die Web Speech API des Browsers — kein externer Dienst, keine Kosten,
  keine Datenuebertragung (DSGVO-unkritisch).

  Liegt bewusst im Theme und nicht im Seiten-Body: der Shopify-Editor loescht
  <script>/<style> beim Speichern einer Seite.
*/
(function () {
  'use strict';

  if (window.__viworoVorlesenInit) return;
  window.__viworoVorlesenInit = true;

  var synth = window.speechSynthesis;
  if (!synth || typeof window.SpeechSynthesisUtterance !== 'function') return;

  /* Der Wrapper wurde in den Uebersetzungen teils mituebersetzt
     (IT .viworo-articolo · DE .viworo-artikel · EN .viworo-article). */
  var article = document.querySelector('.viworo-articolo, .viworo-artikel, .viworo-article, .dormire-guida');
  if (!article) return;

  /* ── Sprache ── */
  var pageLang = (document.documentElement.getAttribute('lang') || 'de').slice(0, 2).toLowerCase();
  if (pageLang !== 'de' && pageLang !== 'it' && pageLang !== 'en') pageLang = 'en';

  var T = {
    de: {
      play: 'Artikel vorlesen', pause: 'Pause', resume: 'Weiterlesen', stop: 'Stopp',
      min: 'Min.', hint: 'Vorlesen durch deinen Browser',
      started: 'Vorlesen gestartet', paused: 'Vorlesen pausiert', ended: 'Vorlesen beendet'
    },
    it: {
      play: "Ascolta l'articolo", pause: 'Pausa', resume: 'Riprendi', stop: 'Stop',
      min: 'min', hint: 'Lettura vocale del tuo browser',
      started: 'Lettura avviata', paused: 'Lettura in pausa', ended: 'Lettura terminata'
    },
    en: {
      play: 'Listen to this article', pause: 'Pause', resume: 'Resume', stop: 'Stop',
      min: 'min', hint: 'Read aloud by your browser',
      started: 'Reading started', paused: 'Reading paused', ended: 'Reading finished'
    }
  }[pageLang];

  var BCP = { de: 'de-DE', it: 'it-IT', en: 'en-GB' }[pageLang];

  /* ── Text einsammeln: pro Block, in Dokumentreihenfolge ── */
  var BLOCKS = 'h1, h2, h3, h4, p, li, blockquote';
  var SKIP = { SCRIPT: 1, STYLE: 1, NAV: 1, NOSCRIPT: 1 };

  function collect() {
    var out = [];
    var nodes = article.querySelectorAll(BLOCKS);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var skip = false;
      for (var p = el; p && p !== article; p = p.parentNode) {
        if (SKIP[p.nodeName]) { skip = true; break; }
      }
      if (skip) continue;
      /* verschachtelte Bloecke nicht doppelt lesen (z.B. <p> in <li>) */
      if (el.querySelector(BLOCKS)) continue;
      var txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (txt.length < 2) continue;
      out.push({ el: el, text: txt });
    }
    return out;
  }

  var blocks = collect();
  if (blocks.length < 3) return;

  /* Titel der Seite voranstellen */
  var h1 = document.querySelector('h1');
  var titleText = h1 ? (h1.textContent || '').replace(/\s+/g, ' ').trim() : '';

  /* ── Chrome bricht lange Utterances nach ~15 s ab -> in Saetze zerlegen ── */
  var MAX = 160;

  /* Saetze, die allein schon zu lang sind, an Kommas bzw. notfalls an Wortgrenzen teilen */
  function split(sentence) {
    if (sentence.length <= MAX) return [sentence];
    var out = [], buf = '';
    var parts = sentence.split(/(?<=[,;:–—])\s+/);
    for (var i = 0; i < parts.length; i++) {
      var pc = parts[i];
      while (pc.length > MAX) {
        var cut = pc.lastIndexOf(' ', MAX);
        if (cut < 40) cut = MAX;
        out.push(pc.slice(0, cut).trim());
        pc = pc.slice(cut);
      }
      if ((buf + ' ' + pc).trim().length > MAX && buf) { out.push(buf.trim()); buf = ''; }
      buf += (buf ? ' ' : '') + pc;
    }
    if (buf.trim()) out.push(buf.trim());
    return out;
  }

  function chunk(text) {
    if (text.length <= MAX) return [text];
    var sentences = text.match(/[^.!?…]+[.!?…]*\s*/g) || [text];
    var out = [], buf = '';
    for (var i = 0; i < sentences.length; i++) {
      var s = sentences[i];
      if (s.trim().length > MAX) {
        if (buf.trim()) { out.push(buf.trim()); buf = ''; }
        out = out.concat(split(s.trim()));
        continue;
      }
      if ((buf + s).length > MAX && buf) { out.push(buf.trim()); buf = ''; }
      buf += s;
    }
    if (buf.trim()) out.push(buf.trim());
    return out;
  }

  var queue = [];
  if (titleText) queue.push({ el: null, text: titleText });
  for (var b = 0; b < blocks.length; b++) {
    var cs = chunk(blocks[b].text);
    for (var c = 0; c < cs.length; c++) queue.push({ el: blocks[b].el, text: cs[c] });
  }

  /* Geschaetzte Dauer: ~150 Woerter/Minute */
  var words = 0;
  for (var w = 0; w < queue.length; w++) words += queue[w].text.split(' ').length;
  var minutes = Math.max(1, Math.round(words / 150));

  /* ── Stimme passend zur Sprache ── */
  var voice = null;
  function pickVoice() {
    var vs = synth.getVoices() || [];
    var exact = null, loose = null;
    for (var i = 0; i < vs.length; i++) {
      var l = (vs[i].lang || '').replace('_', '-');
      if (l.toLowerCase() === BCP.toLowerCase()) { exact = vs[i]; break; }
      if (!loose && l.slice(0, 2).toLowerCase() === pageLang) loose = vs[i];
    }
    voice = exact || loose || null;
  }
  pickVoice();
  if (typeof synth.onvoiceschanged !== 'undefined') {
    synth.addEventListener('voiceschanged', pickVoice);
  }

  /* ── UI ── */
  var css = document.createElement('style');
  css.textContent =
    '.vwtts{display:flex;align-items:center;gap:.6rem;flex-wrap:wrap;background:#f3f7f2;border:1px solid #dde5dd;' +
    'border-radius:10px;padding:.7rem .9rem;margin:0 0 1.4rem;font-size:.92em;color:#2b2b2b;}' +
    '.vwtts button{display:inline-flex;align-items:center;gap:.4rem;background:#2d572c;color:#fff;border:none;' +
    'border-radius:8px;padding:.55rem 1rem;font:inherit;font-weight:600;cursor:pointer;min-height:44px;}' +
    '.vwtts button:hover{background:#41725e;}' +
    '.vwtts button.vwtts-sec{background:transparent;color:#41725e;border:1px solid #cfe0cd;font-weight:500;}' +
    '.vwtts button.vwtts-sec:hover{background:#e7f0e6;color:#2d572c;}' +
    '.vwtts-meta{color:#5a6b5a;font-size:.92em;}' +
    '.vwtts-live{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;}' +
    '.vwtts-on{background:#eef7ec;box-shadow:-3px 0 0 0 #41725e;border-radius:0 4px 4px 0;transition:background .2s;}' +
    '@media (max-width:480px){.vwtts button{flex:1 1 auto;justify-content:center;}}';
  document.head.appendChild(css);

  var bar = document.createElement('div');
  bar.className = 'vwtts';
  bar.innerHTML =
    '<button type="button" class="vwtts-main"><span aria-hidden="true">&#9654;</span> <span class="vwtts-label"></span></button>' +
    '<button type="button" class="vwtts-sec vwtts-stop" hidden></button>' +
    '<span class="vwtts-meta"></span>' +
    '<span class="vwtts-live" role="status" aria-live="polite"></span>';

  var btnMain = bar.querySelector('.vwtts-main');
  var btnStop = bar.querySelector('.vwtts-stop');
  var lblMain = bar.querySelector('.vwtts-label');
  var meta = bar.querySelector('.vwtts-meta');
  var live = bar.querySelector('.vwtts-live');

  lblMain.textContent = T.play;
  btnStop.textContent = T.stop;
  meta.textContent = '· ' + minutes + ' ' + T.min + ' · ' + T.hint;

  /* Einhaengen: nach dem Artikelkopf bzw. der Serien-Navi, sonst ganz oben.
     So steht die Leiste nie zwischen Ueberschrift und Einleitung. */
  var after = article.querySelector('header') || article.querySelector('nav');
  if (after && after.parentNode === article) {
    if (after.nextSibling) {
      article.insertBefore(bar, after.nextSibling);
    } else {
      article.appendChild(bar);
    }
  } else {
    article.insertBefore(bar, article.firstChild);
  }

  /* ── Steuerung ── */
  var idx = 0, playing = false, current = null, highlighted = null;

  function highlight(el) {
    if (highlighted && highlighted !== el) highlighted.classList.remove('vwtts-on');
    if (el) el.classList.add('vwtts-on');
    highlighted = el;
  }

  function setState(state) {
    if (state === 'playing') {
      btnMain.innerHTML = '<span aria-hidden="true">&#10073;&#10073;</span> <span class="vwtts-label">' + T.pause + '</span>';
      btnStop.hidden = false;
      live.textContent = T.started;
    } else if (state === 'paused') {
      btnMain.innerHTML = '<span aria-hidden="true">&#9654;</span> <span class="vwtts-label">' + T.resume + '</span>';
      btnStop.hidden = false;
      live.textContent = T.paused;
    } else {
      btnMain.innerHTML = '<span aria-hidden="true">&#9654;</span> <span class="vwtts-label">' + T.play + '</span>';
      btnStop.hidden = true;
      live.textContent = state === 'ended' ? T.ended : '';
    }
  }

  function speakNext() {
    if (idx >= queue.length) { stop('ended'); return; }
    var item = queue[idx];
    highlight(item.el);
    var u = new SpeechSynthesisUtterance(item.text);
    u.lang = BCP;
    if (voice) u.voice = voice;
    u.rate = 0.95;
    u.pitch = 1;
    u.onend = function () {
      if (!playing) return;
      idx++;
      speakNext();
    };
    u.onerror = function (e) {
      /* 'interrupted'/'canceled' entstehen beim Stoppen — kein echter Fehler */
      if (!playing || (e && (e.error === 'interrupted' || e.error === 'canceled'))) return;
      idx++;
      speakNext();
    };
    current = u;
    synth.speak(u);
  }

  function start() {
    synth.cancel();
    idx = 0;
    playing = true;
    setState('playing');
    speakNext();
  }

  function stop(reason) {
    playing = false;
    current = null;
    synth.cancel();
    highlight(null);
    idx = 0;
    setState(reason || 'idle');
  }

  btnMain.addEventListener('click', function () {
    if (!playing) {
      start();
    } else if (synth.paused) {
      synth.resume();
      setState('playing');
    } else {
      synth.pause();
      setState('paused');
    }
  });

  btnStop.addEventListener('click', function () { stop('idle'); });

  /* Beim Verlassen der Seite verstummen */
  window.addEventListener('beforeunload', function () { synth.cancel(); });
  window.addEventListener('pagehide', function () { synth.cancel(); });
})();
